import * as React from "react";
const SvgViewList = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="33 31 18 22"
    fill="none"
    {...props}
  >

    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M34 48h16M34 36h16zm0 4h16zm0 4h16z"
    />
  </svg>
);
export default SvgViewList;
